import {Rule} from "../../domain/rule"

export interface IRulesApi {
  getRuleForTransaction(transactionId: string, signal?: AbortSignal): Promise<Rule | null>
  saveRule(rule: Rule, signal?: AbortSignal): Promise<Rule>
  deleteRule(ruleId: string, signal?: AbortSignal): Promise<void>
}

export class RulesApi implements IRulesApi {
  constructor(private baseUrl: string) {
  }

  async getRuleForTransaction(transactionId: string, signal?: AbortSignal): Promise<Rule | null> {
    const url = `${this.baseUrl}/rules/transaction/${transactionId}`
    const response = await fetch(url, {method: "get", signal, credentials: "include"})
    if (!response.ok) throw new Error("Error occurred when getting rule for transaction")
    return await response.json()
  }

  async saveRule(rule: Rule, signal?: AbortSignal): Promise<Rule> {
    const url = `${this.baseUrl}/rules`
    const response = await fetch(url, {method: "post", body: JSON.stringify(rule), headers: {"Content-Type": "application/json"}, signal, credentials: "include"})
    if (!response.ok) throw new Error("Error occurred when saving rule")
    const savedRule = await response.json()

    await this.applyRule(savedRule)

    return savedRule
  }

  private async applyRule(rule: Rule, signal?: AbortSignal): Promise<void> {
    const url = `${this.baseUrl}/rules/apply/${rule.id}`
    const response = await fetch(url, {method: "post", signal, credentials: "include"})
    if (!response.ok) throw new Error("Error occurred when applying rule")
  }

  async deleteRule(ruleId: string, signal?: AbortSignal): Promise<void> {
    const url = `${this.baseUrl}/rules/${ruleId}`
    const response = await fetch(url, {method: "delete", signal, credentials: "include"})
    if (!response.ok) throw new Error("Error occurred when deleting rule")
  }

}
